import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { MBaseTextField } from '../BaseTextField/BaseTextField';
import { DumpIco } from '../icons/Dump/Dump';
import { BaseTypography } from '..';

type PInterviewExampleFields = {
  value: Array<string>;
  onChange: (values: string[]) => void;
  minElem?: number;
  maxElem?: number;
  inputLabel: string;
  addMoreText?: string;
  placeholderPattern?: string;
  name: string;
  formik?: any;
  disableDelete?: boolean;
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridGap: '15px',
  },
  inputFieldWrapper: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    // basket styles
    '& > *:nth-child(2)': {
      marginLeft: '15px',
    },
  },
  addMore: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    cursor: 'pointer',
  },
}));

export const BaseInputsGroup: React.FC<PInterviewExampleFields> = (props) => {
  const classes = useStyles();
  const {
    value,
    onChange,
    minElem = 1,
    maxElem = 10,
    inputLabel,
    addMoreText = '+ Add an example',
    placeholderPattern = '',
    name,
    formik,
    disableDelete = false
  } = props;

  const [localValue, setLocalValue] = useState<string[]>([]);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  function handleRemove(clickedIndex: number) {
    onChange(value.filter((el, index) => index !== clickedIndex));
  }

  function handleLocalChange(newValue: string, clickedIndex: number) {
    setLocalValue(
      localValue.map((el, index) => {
        if (index !== clickedIndex) return el;
        return newValue;
      }),
    );
  }

  function handlePropsChange() {
    onChange(localValue);
  }

  return (
    <div className={classes.root}>
      {localValue.map((input, index) => {
        const placeholder = placeholderPattern.replace(
          '{{index}}',
          `${index + 1}`,
        );
        return (
          // eslint-disable-next-line react/no-array-index-key
          <div className={classes.inputFieldWrapper} key={index}>
            <MBaseTextField
              onChange={(e: any) => handleLocalChange(e.target.value, index)}
              onBlur={handlePropsChange}
              value={name === 'images' ? input?.image : input}
              fullWidth
              placeholder={placeholder}
              label={index === 0 ? inputLabel : ''}
              errorText={
                (formik?.errors[name] && formik.errors[name][index]) || ''
              }
            />
            {(index + 1 > minElem && !disableDelete) && (
              <DumpIco onClick={() => handleRemove(index)} />
            )}
          </div>
        );
      })}
      {value.length < maxElem && (
        <BaseTypography
          onClick={() => onChange([...value, ''])}
          className={classes.addMore}
        >
          {addMoreText}
        </BaseTypography>
      )}
    </div>
  );
};
